const TypePolicys = {
  Query: {
    fields: {},
  },
};

export default TypePolicys;
